import Character from "../characters/Character";
import { IItem, Item } from "./Item";
import healingPotion from '../../assets/img/potions/potion.png'
import healingPotionWebp from '../../assets/img/potions/potion.webp'
import { soundToPlay } from "../sounds/sound";

export const initPotion: IItem = {
    initType: 'potion',
    initCount: 1,
    initCost: 50,
    initImages: { webp: healingPotionWebp, img: healingPotion },
    initArmorType: null,
    initWeaponType: null,
    initStackable: true,
    initName: 'Small healing potion',
    initRestoreValue: 5,
    initArmorValue: 0,
    initWeaponDamage: 0
}

export class Potion extends Item {
    constructor(potion: IItem) {
        super(potion)
        this.restoreValue = 5
    }

    useItem(character: Character): void {
        if (this.getCount() <= 0) return
        if (character.getHp() + this.restoreValue > character.getMaxHp()) {
            character.setHp(character.getMaxHp())
        } else {
            character.setHp(character.getHp() + this.restoreValue)
        }
        this.setCount(this.getCount() - 1)
        soundToPlay("potion")

        // * бесконечніе зелья восстанавливающие свіше макс ХП
        // this.setCount(this.getCount() - 1)
        // character.setHp(character.getHp() + 5)
    }

    getClone() {
        return new Potion({
            initType: this.type,
            initCount: this.count,
            initCost: this.cost,
            initImages: this.images,
            initArmorType: null,
            initWeaponType: null,
            initStackable: this.stackable,
            initName: this.name,
            initRestoreValue: this.restoreValue,
            initArmorValue: this.armorValue,
            initWeaponDamage: this.weaponDamage
        })
    }

}